export const paymentReceipt = ({ id, token }) => ({
  HTTPMethod: "get",
  path: `/payments/${id}/receipt`,
  queryParams: {},
  body: null,
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
